import { useEffect } from 'react';
import { motion } from 'framer-motion';
import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';
import { classNames } from '@/utils/class-names';
import { useCircleContainer } from '../hooks/useCircleContainer';

const CircleContainer = () => {
  const {
    positionWheel,
    emotions,
    L2,
    onUpdateSlices,
    radius,
    generateGradients,
    generateSlices,
    generateText,
    gradient1From,
  } = useCircleContainer();

  useEffect(() => {
    if (emotions) {
      onUpdateSlices(emotions, null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emotions]);

  const renderPointer = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="74"
      height="93"
      viewBox="0 0 66 85"
      style={{
        WebkitFilter: 'drop-shadow(0px 6.84px 6.84px rgba(0, 0, 0, 0.15))',
        filter: 'drop-shadow(0px 6.84px 6.84px rgba(0, 0, 0, 0.15))',
      }}
      fill="none"
      className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
      <ellipse cx="33" cy="52.1126" rx="32.5" ry="32.3099" fill="#FAFCFE" />
      <path d="M33.0003 0L39.3558 21.1056H26.6448L33.0003 0Z" fill="#FCFDFF" />
    </svg>
  );

  const renderSlices = () => (
    <motion.svg
      className="cursor-pointer"
      width={radius * 2}
      height={radius * 2}
      viewBox={`0 0 ${radius * 2} ${radius * 2}`}
      animate={{ rotate: positionWheel + 360 }}
      transition={{ duration: 1.5, ease: 'easeInOut' }}
      style={{
        originX: '50%',
        originY: '50%',
      }}>
      <defs>{generateGradients()}</defs>
      {generateSlices()}
      {generateText()}
    </motion.svg>
  );

  const renderLastCircle = () => (
    <AnimatedFadeInComponent
      style={{
        backgroundColor: `#${gradient1From}`,
      }}
      className={classNames(`mt-8 flex size-[300px] items-center justify-center rounded-full xl:mt-0`)}>
      <p className=" text-sh-md font-bold">{L2?.emotion}</p>
    </AnimatedFadeInComponent>
  );

  return (
    <>
      {!L2 && (
        <div className="relative">
          {renderSlices()}
          {renderPointer()}
        </div>
      )}

      {L2 && renderLastCircle()}
    </>
  );
};

export default CircleContainer;
